import styles from "../styles/profile.module.scss";
import SubscriptionCard from "./SubscriptionCard";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../store/store";
import { Subscription } from "../../../types";
import useSubscriptions from "../../../hooks/useSubscriptions";

const SubscriptionsData = [
  {
    id: 1,
    amount: "oneMonth",
    total: 97,
    price: 97,
    total_ua: 97,
    price_ua: 97,
    discount: "",
  },
  {
    id: 2,
    amount: "oneYear",
    total: 864,
    price: 72,
    total_ua: 864,
    price_ua: 72,
    discount: "25%",
  },
];

const Subscriptions = () => {
  const [subsData, setSubsData] = useState(SubscriptionsData);
  const [priceUpToDate, setPriceUpToDate] = useState<boolean>(false);

  const { subscribe } = useSubscriptions();
  const { t } = useTranslation();

  const subscriptionsList = useAppSelector((state: any) => state.subscriptions.subscriptionsList);
  const userData = useAppSelector((state: any) => state.auth.userData);

  useEffect(() => {
    if (subscriptionsList.length) {
      setSubsData((prevState) => {
        const data = prevState;

        subscriptionsList.forEach((item: Subscription) => {
          if (item?.billing_period === "month") {
            data[0].total = +item?.price;
            data[0].price = +item?.price;
            data[0].total_ua = +item?.price;
            data[0].price_ua = +item?.price;
          }

          if (item.billing_period === "year") {
            data[1].total = +item?.price;
            data[1].price = +item?.price;
            data[1].total_ua = +item?.price;
            data[1].price_ua = +item?.price;
          }
        });

        setPriceUpToDate(true);
        return data;
      });
    }
  }, [subscriptionsList]);

  const allSubsData = userData?.subscription?.is_active
    ? subsData?.filter((item) => item.id !== userData?.product_id)
    : subsData;

  return (
    <div>
      <div className={styles.subscriptionSubTitle}>{t("subBlockTitle")}</div>

      <div className={styles.subscriptionDescr}>{t("mySubs")}</div>
      {userData?.has_monthly_subscription || userData?.has_yearly_subscription ? (
        <>
          {(() => {
            const now = new Date();

            const validSubs = userData.subscriptions.filter(
              (sub: any) => sub?.is_active && new Date(sub.next_pay_at) > now,
            );

            if (validSubs.length === 0) return null;

            const subWithLatestPayment = validSubs.reduce((latest: any, current: any) => {
              return new Date(current.next_pay_at) > new Date(latest.next_pay_at) ? current : latest;
            });

            let index = 0;
            if (subWithLatestPayment.product_name === "One year") {
              index = 1;
            }

            return (
              <SubscriptionCard
                isActiveFlag={true}
                subscribe={() => {}}
                priceUpToDate={priceUpToDate}
                key={subsData[index].id}
                amount={t(subsData[index].amount)}
                total={subsData[index].total}
                price={subsData[index]?.price}
                discount={subsData[index].discount}
                id={subsData[index].id}
              />
            );
          })()}
        </>
      ) : (
        <SubscriptionCard
          isActiveFlag={true}
          subscribe={() => {}}
          priceUpToDate={priceUpToDate}
          amount={t("free")}
          total={0.0}
          price={0.0}
          discount={""}
          id={0}
        />
      )}
      <div className={styles.subscriptionDescr}>{t("choosePlan")}</div>
      {allSubsData.map((item: any) => {
        const fieldForCheck = item.id === 1 ? "has_monthly_subscription" : "has_yearly_subscription";
        return (
          <SubscriptionCard
            isActiveFlag={userData[fieldForCheck]}
            subscribe={subscribe}
            priceUpToDate={priceUpToDate}
            key={item.id}
            amount={t(item.amount)}
            total={item.total}
            price={item?.price}
            discount={item.discount}
            id={item.id}
          />
        );
      })}
    </div>
  );
};

export default Subscriptions;
